// extracted by mini-css-extract-plugin
module.exports = {"GradientBackground":"GradientBackground_GradientBackground__3QCKV"};